<menu ng-click="onMenuClick()">
    <i class="fa fa-th"></i>
    <span class="top-bar-text" data-module="{{currentModule}}">{{currentStateName}}</span>
    <nav class="service-menu" c-toggle="menuVisible" c-toggle-type="fade">
        <div c-module-navigator class="main-menu"></div>
        <div class="user-menu">
            <div class="user">{{currentUser.displayName}}</div>
            <div class="user-name">{{currentUser.userName}}</div>
            <div class="user-role">{{currentUserRole}}</div>
            <div class="user-actions">
                <div ng-if="showSettings()" ng-click="userSettings()">{{'user.settings'|translate}}</div>
                <div ng-click="logout()" ng-if="currentUser.canLogout">{{'logout'|translate}}</div>
                <div class="debug" ng-if="isDebugging" ng-click="refreshLanguage()">{{'dev.refresh.translation'|translate}}</div>
            </div>

            <div class="centuri-version">{{version}}</div>
        </div>
    </nav>
</menu>